export const getDataListColDefs = (
    handleExpansionToggleCallback: (data: any) => void,
    handleDetailsClickCallback: (data: any) => void,
    handleActionCallback: (action: number, data: any) => void,
    errorCount: number,
    isAtleastOneErrorFixed: boolean
) => [
    {
        field: 'name',
        headerName: 'Name',
        minWidth: 450,
        resizable: true,
        cellRenderer: 'nameCellRenderer',
        cellRendererParams: {
            onExpansionToggle: handleExpansionToggleCallback
        },
        cellClass: 'name-cell-custom',
        headerClass: 'name-header-custom'
    },
    {
        field: 'errors',
        headerName: 'Errors',
        resizable: true,
        cellRenderer: 'errorCellRenderer',
        headerComponent: 'errorHeaderRenderer',
        headerComponentParams: {
            count: errorCount,
            isAtleastOneErrorFixed: isAtleastOneErrorFixed
        }
    },
    {
        field: 'order',
        headerName: 'Order',
        resizable: true,
        cellRenderer: 'orderCellRenderer'
    },
    {
        field: 'details',
        headerName: 'Details',
        resizable: true,
        cellRenderer: 'detailsCellRenderer',
        cellRendererParams: {
            handleDetailsClick: handleDetailsClickCallback
        }
    },
    {
        field: 'actions',
        headerName: '',
        minWidth: 150,
        resizable: true,
        cellRenderer: 'actionCellRenderer',
        cellRendererParams: {
            onAction: handleActionCallback
        }
    }
];
